"use client";

import Link from 'next/link';
import { CircleChevronLeft } from "lucide-react";
import { useRouter, usePathname } from "next/navigation";
import "./Header.css";


const Header = () => {
  const router = useRouter();
  const pathname = usePathname();
  const handleBack = () => router.back();
  return (

    <header className="Header-container">
      <div className="navigate-container">
        <button
          onClick={handleBack}
          title="Go Back"
          className={pathname === "/" ? "invisible-button" : ""}
          disabled={pathname === "/"}
        >
          <CircleChevronLeft size={28} />
        </button>
      </div>
      <div className="header-cropper">
        <div className="logo-container">
          <Link href="/" aria-label="Home" title='Home'>
            <img
              src="/images/logo/TownLITLogo.png"
              alt="TownLIT Logo"
            />
          </Link>
        </div>

      </div>

    </header>
  );
};

export default Header;
